import { TAX_CLS_VIEW_LOADED, TAX_CLS_LISTED_ALL, TAX_CLS_UNLOAD } from '../actions/taxClass/action_types';

const initialStore = {
  isLoaded: false,
  taxClass: {},
  taxClasses: []
};

const load = (state, obj) =>
  Object.assign({}, state, {
    isLoaded: true,
    taxClass: obj,
    taxClasses: []
  });

const loadAll = (state, array) =>
  Object.assign({}, state, {
    isLoaded: true,
    taxClass: {},
    taxClasses: array
  });

export default function taxClass(state = initialStore, action) {
  switch (action.type) {
    case TAX_CLS_VIEW_LOADED:
      return load(state, action.payload);
    case TAX_CLS_LISTED_ALL:
      return loadAll(state, action.payload);
    case TAX_CLS_UNLOAD:
      return Object.assign({}, state, initialStore);
    default:
      return state;
  }
}
